import Cross from '@/components/icons/Cross';
import { ButtonHTMLAttributes, FC } from 'react';
import styles from './style.module.scss';

const CloseButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className = '',
  ...props
}) => {
  return (
    <button {...props} className={styles.button + ' ' + className}>
      <Cross className={styles.cross}></Cross>
    </button>
  );
};

export default CloseButton;
